"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.findMarked = exports.createMarker = void 0;

var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/define-property"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/symbol"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/some"));

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find-index"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _minSafeInteger = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/number/min-safe-integer"));

var React = _interopRequireWildcard(require("react"));

var _index = _minSafeInteger.default;
/**
 * A unique identifier that can be used to mark and identify marked React
 * components.
 */

/**
 * Create a `ComponentMarker`, which is a unique identifier that can be used to
 * mark and identify marked React components.
 *
 * Exporting a marker also allows for component extension by allowing 3rd party
 * components to mark themselves for consumption by a marker aware parent, or
 * to consume marked children.
 *
 * This is especially helpful wrapping a component that is only recognized by
 * a direct parent. Wrapping the component would normally move it down a level
 * in the React tree, hiding it from the parent. Using a marker, the wrapper
 * can now mark itself so that it is also recognized the same way the wrapped
 * component was.
 */
var createMarker = function createMarker(name) {
  return new ComponentMarker(name);
};
/**
 * Find an bucket components with specific markers.
 *
 * The returned array contains a sub-array for each provided marker, plus one
 * for components that did not match any of the given markers.
 *
 * To combine multiple markers into a single bucket, wrap them in an array.
 */


exports.createMarker = createMarker;

var findMarked = function findMarked(children) {
  var _context;

  for (var _len = arguments.length, markers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    markers[_key - 1] = arguments[_key];
  }

  var results = [];

  while (results.length <= markers.length) {
    results.push([]);
  }

  (0, _forEach.default)(_context = React.Children).call(_context, children, function (child) {
    var i = (0, _findIndex.default)(markers).call(markers, function (marker) {
      if (marker instanceof Array) {
        return (0, _some.default)(marker).call(marker, function (m) {
          return m.isMarked(child);
        });
      } else {
        return marker.isMarked(child);
      }
    });
    results[i < 0 ? results.length - 1 : i].push(child);
  });
  return results;
};

exports.findMarked = findMarked;

var ComponentMarker = /*#__PURE__*/function () {
  function ComponentMarker(name) {
    var _context2;

    (0, _classCallCheck2.default)(this, ComponentMarker);
    this._symbol = void 0;
    this._symbol = typeof _symbol.default !== 'undefined' ? (0, _symbol.default)(name) : (0, _concat.default)(_context2 = "__ComponentMarker__".concat(name, "__")).call(_context2, _index++, "__");
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  (0, _createClass2.default)(ComponentMarker, [{
    key: "mark",
    value: function mark(componentType) {
      (0, _defineProperty.default)(componentType, this._symbol, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: true
      });
      return componentType;
    }
  }, {
    key: "isMarked",
    value: function isMarked(node) {
      return /*#__PURE__*/React.isValidElement(node) && typeof node.type === 'function' && this._symbol in node.type;
    }
  }]);
  return ComponentMarker;
}();